module.exports = __webpack_public_path__ + "static/media/icon-buy.fab94b94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-buy.svg
// module id = 1249
// module chunks = 19